// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070005/js/" + chunkId + "." + {"44":"0b0a6f86","225":"9f912fb6","481":"b426a243","486":"4f90afd7","770":"7336ac28"}[chunkId] + ".0.35818799089251585.chunk.js";
};